import { render } from "./ProviderGroups.vue?vue&type=template&id=57cb4ec4&scoped=true&lang=pug"
import script from "./ProviderGroups.vue?vue&type=script&lang=js"
export * from "./ProviderGroups.vue?vue&type=script&lang=js"

import "./ProviderGroups.vue?vue&type=style&index=0&id=57cb4ec4&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57cb4ec4"]])

export default __exports__